import React from "react";
import {
  ArrowForwardIos,
  BusinessOutlined,
  CalendarMonthOutlined,
  DescriptionOutlined,
  LocationOnOutlined,
  PaymentsOutlined,
} from "@mui/icons-material";
import { Box, IconButton, LinearProgress, Typography } from "@mui/material";
import StatusChip from "./StatusChip";
import { formatCurrencyWithUnit,} from "utils/formatters";

// const money = (value) => `${new Intl.NumberFormat("vi-VN").format(value || 0)} đ`;
const date = (value) => value ? new Date(value).toLocaleDateString("vi-VN") : "—";

export default function SubcontractListItem({ contract, onClick }) {
  // console.log("SubcontractListItem contract:", contract); // Debugging line
  const start = contract.startDate ? new Date(contract.startDate).getTime() : Date.now();
  const end = contract.endDate ? new Date(contract.endDate).getTime() : start;
  const progress = end > start
    ? Math.max(0, Math.min(100, Math.round(((Date.now() - start) / (end - start)) * 100)))
    : 0;

  return (
    <Box
      component="button"
      type="button"
      className="subcontract-list-item"
      onClick={onClick}
    >
      <Box className="subcontract-list-item__icon">
        <DescriptionOutlined />
      </Box>

      <Box className="subcontract-list-item__content">
        <Box className="subcontract-list-item__heading">
          <Box>
            <Typography className="subcontract-list-item__number">
              {contract.subcontractNumber}
            </Typography>
            <Typography className="subcontract-list-item__name">
              {contract.subcontractName}
            </Typography>
          </Box>
          <Box className="subcontract-list-item__chips">
            <StatusChip value={contract.status} />
            {/* <StatusChip value={contract.approvalStatus || "Tạo mới"} /> */}
          </Box>
        </Box>

        <Box className="subcontract-list-item__meta">
          <span><BusinessOutlined />{contract.subcontractorName || "Chưa xác định đơn vị"}</span>
          <span><DescriptionOutlined />HĐ chính: {contract.contractNumber || "—"}</span>
          <span><CalendarMonthOutlined />{date(contract.startDate)} – {date(contract.endDate)}</span>
          <span><LocationOnOutlined />{contract.provinceName || "Chưa xác định"}</span>
          <span><PaymentsOutlined />{formatCurrencyWithUnit(contract.totalValue)}</span>
        </Box>

        <Box className="subcontract-list-item__progress">
          <Box>
            <span>Thời gian thực hiện</span>
            <strong>{progress}%</strong>
          </Box>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      </Box>

      <IconButton className="subcontract-list-item__arrow" disableRipple>
        <ArrowForwardIos fontSize="small" />
      </IconButton>
    </Box>
  );
}
